import React, { useEffect, useMemo, useState } from "react"
import axios from "axios"
import Cookies from "js-cookie"
import { getFoodImageUrl } from "../utils/foodAvailability"

const API = "https://food-backend-9733.onrender.com"

const AdminOrders = () => {
  const [orders, setOrders] = useState([])
  const [search, setSearch] = useState("")
  const [openOrderId, setOpenOrderId] = useState(null)

  const [currentPage, setCurrentPage] = useState(1)

  const [ordersPerPage, setOrdersPerPage] = useState(10)

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const loadOrders = () => {
    axios.get(
      `${API}/admin/orders-full`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => setOrders(res.data))
    .catch(err => console.log(err))
  }

  useEffect(() => {
    loadOrders()
  }, [])

  const updateStatus = (
    order_id,
    status
  ) => {

    axios.put(
      `${API}/admin/order-status`,
      {
        order_id,
        status
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(() => loadOrders())
    .catch(() =>
      alert("Status update failed")
    )
  }

  const filteredOrders = useMemo(() => {

    const value =
      search.toLowerCase()

    return orders.filter(order => {

      return (
        String(order.id)
          .includes(value) ||

        order.user_name
          ?.toLowerCase()
          .includes(value) ||

        order.phone
          ?.toLowerCase()
          .includes(value) ||

        order.city
          ?.toLowerCase()
          .includes(value) ||

        order.items?.some(item =>
          item.name
            ?.toLowerCase()
            .includes(value)
        )
      )
    })

  }, [orders, search])

  const totalPages = Math.ceil(
    filteredOrders.length /
    ordersPerPage
  )

  const startIndex =
    (currentPage - 1) *
    ordersPerPage

  const paginatedOrders =
    filteredOrders.slice(
      startIndex,
      startIndex + ordersPerPage
    )

  return (

    <div className="admin-orders-page">

      <div className="admin-list-hero">
        <div>
          <span>
            Order Management
          </span>

          <h1>
            Admin Orders
          </h1>

          <p>
            Search, review items and update each delivery status.
          </p>
        </div>

        <div className="admin-list-count">
          <b>{filteredOrders.length}</b>
          <span>Orders</span>
        </div>
      </div>

      <div className="admin-filter-row">

        <input
          className="admin-order-search"
          type="text"

          placeholder="Search order id, customer, phone, item..."

          value={search}

          onChange={(e) => {

            setSearch(e.target.value)

            setCurrentPage(1)
          }}
        />

        <div className="admin-pagination-top">

          <span>
            Show
          </span>

          <select
            value={ordersPerPage}

            onChange={(e) => {

              setOrdersPerPage(
                Number(e.target.value)
              )

              setCurrentPage(1)
            }}
          >

            <option value={10}>
              10 Orders
            </option>

            <option value={25}>
              25 Orders
            </option>

            <option value={50}>
              50 Orders
            </option>

          </select>

          <span>
            per page
          </span>

        </div>

      </div>

      <div className="admin-table-wrapper">

        <table className="admin-orders-table">

          <thead>

            <tr>

              <th>
                Order ID
              </th>

              <th>
                Customer
              </th>

              <th>
                Phone
              </th>

              <th>
                Address
              </th>

              <th>
                Total
              </th>

              <th>
                Payment
              </th>

              <th>
                Status
              </th>

              <th>
                Items
              </th>

            </tr>

          </thead>

          <tbody>

            {
              paginatedOrders.map(order => (

                <React.Fragment
                  key={order.id}
                >

                  <tr>

                    <td>
                      #{order.id}
                    </td>

                    <td>
                      <div className="admin-table-stack">
                        <b>
                          {
                            order.user_name ||
                            "User"
                          }
                        </b>

                        <small>
                          {order.user_email}
                        </small>
                      </div>
                    </td>

                    <td>
                      {
                        order.phone ||
                        "No phone"
                      }
                    </td>

                    <td>
                      <div className="admin-table-stack">
                        <span>{order.address}</span>
                        <small>
                          {order.city}, {order.state}
                        </small>
                        <small>
                          {order.country} - {order.pincode}
                        </small>
                      </div>
                    </td>

                    <td>
                      ₹ {order.total}
                    </td>

                    <td>
                      <div className="admin-table-stack">
                        <span>
                          {order.payment_method}
                        </span>

                        <small>
                          {order.payment_status}
                        </small>
                      </div>
                    </td>

                    <td>

                      <select

                        value={
                          order.order_status ||
                          "pending"
                        }

                        onChange={(e) =>

                          updateStatus(
                            order.id,
                            e.target.value
                          )
                        }
                      >

                        <option value="pending">
                          Pending
                        </option>

                        <option value="confirmed">
                          Confirmed
                        </option>

                        <option value="preparing">
                          Preparing
                        </option>

                        <option value="out for delivery">
                          Out For Delivery
                        </option>

                        <option value="delivered">
                          Delivered
                        </option>

                        <option value="cancelled">
                          Cancelled
                        </option>

                      </select>

                    </td>

                    <td>

                      <button
                        className="view-items-btn"

                        onClick={() =>

                          setOpenOrderId(

                            openOrderId === order.id
                              ? null
                              : order.id
                          )
                        }
                      >

                        {
                          openOrderId === order.id
                            ? "Hide Items"
                            : "View Items"
                        }

                      </button>

                    </td>

                  </tr>

                  {
                    openOrderId === order.id && (

                      <tr>

                        <td colSpan="8">

                          <div className="order-items-box">

                            {
                              order.items?.map(item => (

                                <div
                                  key={item.id}

                                  className="admin-order-item-card"
                                >

                                  <img
                                    src={getFoodImageUrl(item, API)}
                                    alt={item.name}
                                    onError={(e) => {
                                      e.currentTarget.src = "/logo192.png"
                                    }}
                                  />

                                  <div>

                                    <h3>
                                      {item.name}
                                    </h3>

                                    <p>
                                      Size:
                                      {" "}
                                      {
                                        item.selected_size
                                      }
                                    </p>

                                    <p>
                                      Quantity:
                                      {" "}
                                      {
                                        item.quantity
                                      }
                                    </p>

                                    <p>
                                      Price:
                                      {" "}
                                      ₹ {item.price}
                                    </p>

                                  </div>

                                </div>
                              ))
                            }

                          </div>

                        </td>

                      </tr>
                    )
                  }

                </React.Fragment>
              ))
            }

          </tbody>

        </table>

      </div>

      <div className="admin-pagination">

        <button
          disabled={currentPage === 1}

          onClick={() =>

            setCurrentPage(
              currentPage - 1
            )
          }
        >
          Previous
        </button>

        <span>

          Page
          {" "}
          {currentPage}
          {" "}
          of
          {" "}
          {totalPages || 1}

        </span>

        <button

          disabled={
            currentPage === totalPages ||
            totalPages === 0
          }

          onClick={() =>

            setCurrentPage(
              currentPage + 1
            )
          }
        >
          Next
        </button>

      </div>

    </div>
  )
}

export default AdminOrders
